import {Component, OnInit, Input, OnDestroy, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroup} from '../../shared/models/routeGroup.model';
import {Vehicle} from '../../shared/models/vehicle.model';
import {DispatchCreate, Dispatch} from '../../shared/models/dispatch.model';
import {DispatchGroup} from '../../shared/models/dispatchGroup.model';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import {Comment} from "../../shared/models/comment.model";

@Component({
    selector: 'form-dispatch',
    templateUrl: 'form-dispatch.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormDispatchComponent implements OnInit, OnDestroy {
    constructor(
        private routeService: RouteService,
        private changeDetector: ChangeDetectorRef,
        private dataStorageService: DataStorageService) {
    }

    @Input() date: any;
    date_comments_oz: Comment[];
    date_comments_ke: Comment[];

    dispatchForm: FormGroup;
    routeGroups: RouteGroup[];
    dispatchGroups: DispatchGroup[];
    vehicles: Vehicle[];

    routeGroupOptions: any = [];
    vehicleOptions: any = [];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    routeGroupSelectValue = '';
    vehicleSelectValue = '';

    dispatches: Dispatch[];

    is_valid = false;

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {

        this.dispatchGroups = this.routeService.getDispatchGroup();
        this.initDispatchGroupOptions(this.dispatchGroups);

        this.initForm();

        this.dataStorageService.fetchOzCommentsDate(this.date)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            comments => {
                this.date_comments_oz = comments;
            }
        );
        this.dataStorageService.fetchKeCommentsDate(this.date)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            comments => {
                this.date_comments_ke = comments;
            }
        );

        this.routeService.dispatchGroupsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (dispatchGroups: DispatchGroup[]) => {
                    this.initDispatchGroupOptions(dispatchGroups);
                }
            );

        this.vehicles = this.routeService.getVehicles();
        if (this.vehicles) {
            this.initVehicleOptions(this.vehicles);
        }

        this.dataStorageService.fetchDispatchesDate(this.date)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (dispatches) => {
                    this.dispatches = dispatches;
                    this.changeDetector.detectChanges();
                }
            );
    }

    initForm() {
        this.dispatchForm = new FormGroup({
            'vehicle_id': new FormControl(),
            'dispatch_group_id': new FormControl()
        });
    }

    initDispatchGroupOptions(dispatchGroups: DispatchGroup[]) {
        for (const dispatchGroup of dispatchGroups) {
            this.routeGroupOptions.push({'label': dispatchGroup.title, 'value': dispatchGroup.id, 'code': dispatchGroup.title});
        }
    }

    initVehicleOptions(vehicles: Vehicle[]) {
        for (const vehicle of vehicles) {
            this.vehicleOptions.push({'label': vehicle.model + ' (' + vehicle.capacity + ')', 'value': vehicle.id, 'code': vehicle.model});
        }
    }

    checkIsValid() {
        // validators required not working for ng selectize
        const value = this.dispatchForm.value;
        if (value.vehicle_id && value.dispatch_group_id) {
            this.is_valid = true;
        } else {
            this.is_valid = false;
        }
    }

    onAddRoute() {
        const value = this.dispatchForm.value;

        const newDispatch = new DispatchCreate(value.vehicle_id, value.dispatch_group_id);
        newDispatch.date = this.date;
        this.dataStorageService.createDispatch(newDispatch).pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
            if (responseData['error']) {
                console.log('saving dispatch error');
            } else {
                alert('dispatch added. ');
                location.reload();
            }
        });
    }

    onDelete(id: number) {
        this.dataStorageService.deleteComment(id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    console.log('error');
                } else {
                    alert('success. ');
                    location.reload();
                }
            }
        );
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
